import { render, staticRenderFns } from "./SendOtp.vue?vue&type=template&id=6f911027"
import script from "./SendOtp.vue?vue&type=script&lang=js"
export * from "./SendOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports